import { Button } from "@gigpro/ui/Button";
import { Dialog, DialogFooter, DialogTitle } from "@gigpro/ui/Dialog";
import {
  StripePaymentMethodUpdateContainer,
  type StripePaymentMethodUpdateContainerProps,
} from "domains/locations/containers/StripePaymentMethodUpdate";

type SetPaymentMethodDialogProps = {
  open: boolean;
  onCancelUpdate: () => void;
  returnTo: string;
  onSave?: () => Promise<void>;
  title: string;
} & Pick<StripePaymentMethodUpdateContainerProps, "isQwick" | "sourceId">;

const SetPaymentMethodDialog = ({
  open,
  returnTo,
  title,
  onCancelUpdate,
  onSave,
  isQwick,
  sourceId,
}: SetPaymentMethodDialogProps) => (
  <Dialog open={open} onClose={onCancelUpdate} className="sm:max-w-3xl" bottomSheet>
    <DialogTitle>{title}</DialogTitle>
    <StripePaymentMethodUpdateContainer
      className="rounded-sm bg-white"
      returnTo={returnTo}
      onSave={onSave}
      isQwick={isQwick}
      sourceId={sourceId}
      renderButtons={({ isSubmitting, isSaveDisabled }) => (
        <DialogFooter>
          <Button disabled={isSubmitting} className="w-full" type="button" onClick={onCancelUpdate}>
            Cancel
          </Button>
          <Button
            loading={isSubmitting}
            disabled={isSaveDisabled}
            className="w-full"
            variant="contained"
            type="submit"
            data-testid="save-payment-method"
          >
            Save Payment Method
          </Button>
        </DialogFooter>
      )}
    />
  </Dialog>
);
export { SetPaymentMethodDialog };
